<template>
  <div>
    <h3>{{ $t("delegation.form.bookingAndInvoices.listOfAttachedBookings") }}</h3>
    <span v-if="bookings.length === 0">{{ $t("delegation.form.bookingAndInvoices.noAttachedBooking") }}</span>
    <div :key="item.id" v-for="item in bookings">
      <v-card>
        <v-card-text>
          <v-row class="text-no-wrap">
            <v-col cols="8">
              <v-row>
                <v-col style="min-width: 40px; max-width: 50px;" cols="1">
                  <v-tooltip top v-if="item.type.toLowerCase().includes('rail')">
                    <template #activator="{on}">
                      <v-icon v-on="on" x-large>
                        directions_transit
                      </v-icon>
                    </template>
                    {{ $t("delegation.form.bookingAndInvoices.railBooking") }}
                  </v-tooltip>
                  <v-tooltip top v-else-if="item.type.toLowerCase().includes('hotel')">
                    <template #activator="{on}">
                      <v-icon v-on="on" x-large>
                        hotel
                      </v-icon>
                    </template>
                    {{ $t("delegation.form.bookingAndInvoices.hotelBooking") }}
                  </v-tooltip>
                  <v-tooltip top v-else-if="item.type.toLowerCase().includes('flight') || item.type.toLowerCase().includes('lcc')">
                    <template #activator="{on}">
                      <v-icon v-on="on" x-large>
                        flight
                      </v-icon>
                    </template>
                    {{ $t("delegation.form.bookingAndInvoices.flightBooking") }}
                  </v-tooltip>
                  <v-tooltip top v-else>
                    <template #activator="{on}">
                      <v-icon v-on="on" x-large>
                        fa-list-alt
                      </v-icon>
                    </template>
                    {{ $t("delegation.form.bookingAndInvoices.otherBooking") }}
                  </v-tooltip>
                </v-col>
                <v-col cols="11">
                  <strong style="word-wrap: break-word">{{ item.name }}</strong>
                  <br />{{ $t("delegation.form.bookingAndInvoices.reservationNumber") }}: <b>{{ item.reservation_number }}</b>
                </v-col>
              </v-row>
            </v-col>
            <v-spacer />
            <v-col cols="3" v-if="item.invoice_gross_value !== null || item.total_amount !== null" style="white-space: nowrap">
              {{ $t("delegation.form.bookingAndInvoices.totalAmount") }}:
              <span class="datatable-total-amount">
                <template v-if="item.invoice_gross_value !== null">{{ item.invoice_gross_value }} {{ item.invoice_currency }}</template>
                <template v-else>{{ item.total_amount }} PLN</template>
              </span>
              <br />
              <span style="font-size: x-small">
                <template v-if="item.invoice_gross_value !== null">({{ $t("delegation.form.bookingAndInvoices.invoiceAvailable") }})</template>
                <template v-else>({{ $t("delegation.form.bookingAndInvoices.waitingForInvoice") }})</template>
              </span>
            </v-col>
            <!--            <v-flex xs2>-->
            <v-tooltip top>
              <template #activator="{on}">
                <v-btn class="py-5" :disabled="canBeRemoved(item) === false || $store.getters['Ajax/loading']" icon v-on="on" @click="removeBooking(item)">
                  <v-icon>close</v-icon>
                </v-btn>
              </template>
              {{
                canBeRemoved(item) === false
                  ? $t("delegation.form.bookingAndInvoices.bookingAlreadyAttachedAsTravelPart")
                  : $t("delegation.form.bookingAndInvoices.removeAttachedBooking")
              }}
            </v-tooltip>
            <!--            </v-flex>-->
          </v-row>
        </v-card-text>
      </v-card>
    </div>
    <ajax-booking-general-select @selectedBooking="addBooking" v-if="!readonly">
      <v-btn class="primary my-3">{{ $t("delegation.form.bookingAndInvoices.attachBooking") }}</v-btn>
    </ajax-booking-general-select>
  </div>
</template>

<script>
import AjaxBookingGeneralSelect from "../../CustomInputComponents/AjaxBookingGeneralSelect";
export default {
  name: "BookingAndInvoices",
  props: {
    readonly: {
      required: false,
      default: false
    }
  },
  components: { AjaxBookingGeneralSelect },
  data: () => ({
    bookings: []
  }),
  watch: {
    selectedBookings() {
      this.downloadAssignedBookings();
    }
  },
  computed: {
    selectedBookings() {
      return this.$store.getters["Delegation/delegationBookings"];
    }
  },
  mounted() {
    this.downloadAssignedBookings();
  },
  methods: {
    canBeRemoved(item) {
      if (typeof this.selectedBookings.find(v => v.booking_id === item.id) !== "undefined") {
        return this.selectedBookings.find(v => v.booking_id === item.id).label === "manually";
      }
      return false;
    },
    downloadAssignedBookings() {
      let bookingIds = [];
      for (let selectedBooking of this.selectedBookings) {
        bookingIds.push(selectedBooking.booking_id);
      }
      if (bookingIds.length > 0) {
        this.axios.get("/booking/get-delegation-bookings-by-id", { params: { bookingIds: bookingIds } }).then(resp => {
          this.bookings = resp.data;
        });
      }
    },
    addBooking(item) {
      this.$store.dispatch("Delegation/addBooking", { bookingId: item, label: "manually" });
    },
    removeBooking(item) {
      this.$store.commit("Delegation/removeBooking", item.id);
    }
  }
};
</script>

<style scoped></style>
